export const MetersToSkeins = (meters: number) => {
    return meters / 8;
}

export const SkeinsToMeters = (skeins: number) => {
    return skeins * 8;
}
